import React, { FormEvent, useEffect } from 'react';
import useTranslate from '@src/i18n/useTranslate';
import DotFalling from '@src/components/reusable/spinner/DotFalling';
import Input from '@src/features/customers/auth/legacy/inputs/Input';
import {
  AuthContainer,
  AuthForm,
  AuthHeader,
  AuthHeaderTitle,
  AuthHeaderSubtitle,
  AuthInputsGrid,
  AuthButtonGroup,
  AuthPrimaryButton,
  AuthPreviousStepButton,
} from '@src/features/customers/auth/legacy/styled/AuthStyled';
import { extractValues } from '@src/common';
import { RECOVERY_STEP } from '@src/features/customers/types';
import { track } from '@src/services/analytics';
import { usePasswordRecovery } from '@src/features/customers/auth/password-recovery/hooks/usePasswordRecovery';
import { useAppDispatch } from '@src/core/hooks';
import { setErrors } from '@src/features/customers/auth/store/auth';

interface PasswordResetProps {
  onBack: () => void;
}
const PasswordReset = ({ onBack }: PasswordResetProps) => {
  const { i18n } = useTranslate();
  const dispatch = useAppDispatch();
  const { sendResetCode, loading } = usePasswordRecovery();

  useEffect(() => {
    dispatch(setErrors(RECOVERY_STEP.PASSWORD_RESET, {}));

    track('recoveryPasswordEmailStepAccess');
  }, []);

  const handleSubmit = (ev: FormEvent<HTMLFormElement>) => {
    ev.preventDefault();

    const values = extractValues(ev.target as HTMLFormElement);

    track('recoveryPasswordEmailStepSubmit');

    sendResetCode(values.email);
  };

  return (
    <AuthContainer>
      <AuthForm key={RECOVERY_STEP.PASSWORD_RESET} onSubmit={handleSubmit}>
        <AuthHeader>
          <AuthHeaderTitle>{i18n('auth_recoverPassword')}</AuthHeaderTitle>
          <AuthHeaderSubtitle>{i18n('auth_passwordResetSubtitle')}</AuthHeaderSubtitle>
        </AuthHeader>
        <AuthInputsGrid>
          <Input required={true} type='email' name='email' label='E-mail' errorContext={RECOVERY_STEP.PASSWORD_RESET} />
        </AuthInputsGrid>
        <AuthButtonGroup>
          <AuthPrimaryButton>{loading ? <DotFalling /> : i18n('auth_submit')}</AuthPrimaryButton>
          <AuthPreviousStepButton onClick={() => onBack()}>{i18n('auth_goBackButton')}</AuthPreviousStepButton>
        </AuthButtonGroup>
      </AuthForm>
    </AuthContainer>
  );
};

export default PasswordReset;
